/* eslint-disable max-lines-per-function */
import React from 'react';
import { HSPatientPharmacy} from "server-openapi";
import { Dialog } from '../../../../kit/Dialog';
import { TextInput } from '../../../../kit/Forms/TextInput';
import { Layout } from '../../../../kit/Layout';
import { Text } from '../../../../kit/Text';

interface IProps {
    pharmacy: HSPatientPharmacy;
    isOpen: boolean;
    setClosed: () => void;
}

export const PharmacyDetailDialog = (props: IProps) => {
    return (
        <Dialog lazy secondary open={props.isOpen} onRequestClose={() => props.setClosed()} size={'lg'}>
            <PharmacyDetailForm {...props} />
        </Dialog>
    );
};

const PharmacyDetailForm = (props: IProps) => {

    return (
        <div>
            <Layout gap={1}>
                <Text weight={'bold'} size={'medium'}>
                    {props.pharmacy.name}
                </Text>
                <Layout gap={0.5}>
                    <Text weight={'bold'}>Phone</Text>
                    <TextInput disabled name={'phone'} value={props.pharmacy.phone ?? ''} fullWidth />
                </Layout>
                <Layout gap={0.5}>
                    <Text weight={'bold'}>Email</Text>
                    <TextInput disabled name={'email'} value={props.pharmacy.email ?? ''} fullWidth />
                </Layout>
                <Layout gap={0.5}>
                    <Text weight={'bold'}>Address</Text>
                    <TextInput disabled name={'address'} value={props.pharmacy.address ?? ''} fullWidth />
                </Layout>
                <Layout gap={0.5}>
                    <Text weight={'bold'}>State</Text>
                    <TextInput disabled name={'state'} value={props.pharmacy.addressState ?? ''} fullWidth />
                </Layout>
                <Layout gap={0.5}>
                    <Text weight={'bold'}>Postcode</Text>
                    <TextInput disabled name={'postcode'} value={props.pharmacy.postcode ?? ''} fullWidth />
                </Layout>
            </Layout>
        </div>
    );
}